// eslint-disable-next-line import/prefer-default-export
export const GA_EVENTS = {
  ACTION: {
    PROPERTY_VIEW: "amber_property_view",
    TENANCY_VIEW: "amber_tenancy_view",
    ENQUIRE_NOW: "amber_enquire_now",
  },
  LABEL: {
    CLICK_BEHAVIOUR: "click_behaviour",
  },
  CATEGORY: "click_tracking",
  PLATFORM: {
    PARTNERS: "amber_partners",
    GLOBAL: "amber_global",
    MINI_PROGRAM: "amber_mini_program",
    WHITELABEL_MINI: "amber_whitelabel",
  },
} as const;
